import React, { Suspense } from "react"
import ReactDOM from "react-dom"
import * as path from "./constants/Paths"
import ReactHtmlParser from "react-html-parser"

//import BookingStarter from './components/bookingStarter'
const BookingStarter = React.lazy(() => import(/* webpackPrefetch: true */ "./components/bookingStarter"))

export default class ParkingProductBookingStarter {
  constructor(el) {
    const self = this
    self.elem = el
    self.config = {}
    self.lang = {}
    self.productData = {}
    self.init()
    return this
  }
  init() {
    const self = this
    let parkingProductBookingStarterContainer = self.elem
    if (parkingProductBookingStarterContainer) {
      this.productData =
        (parkingProductBookingStarterContainer.dataset.parkingProductBookingstarter &&
          JSON.parse(parkingProductBookingStarterContainer.dataset.parkingProductBookingstarter)) ||
        {}
      const heading = this.productData["heading"] || ""
      const buttonText = this.productData["buttonText"] || ""
      self.lang = document.body.dataset.language
      // PRODUCT CATEGORY NAME I.E. budget etc.
      const productName = self.productData["product"] || ""
      const searchData = self.config["searchData"] || {}
      const locale = self.lang || "da"
      let textKeys = {
        from: self.productData["fromLabel"],
        to: self.productData["toLabel"],
        time: self.productData["timeLabel"],
      }
      ReactDOM.render(
        <Suspense fallback={ReactHtmlParser(parkingProductBookingStarterContainer.innerHTML)}>
          <div className="overlay overlay--modal overlay--fixed is-active">
            <div className="modal modal--takeover">
              <button className="button button--icon js--close-modal" onClick={() => (parkingProductBookingStarterContainer.style.display = "none")}>
                <span className="icon">
                  <svg className="svg-icon svg-icon--close-new">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                      &nbsp;
                    </use>
                  </svg>
                </span>
              </button>
              <div className="modal__content">
                <div className="modal__content__inner">
                  <div className="modal__middle">
                    <BookingStarter
                      searchData={searchData}
                      textKeys={textKeys}
                      performParkingSearch={self.performParkingSearch}
                      showDefaultDates={false}
                      locale={locale}
                      campaignCode={false}
                      headline={heading || "Book parkering"}
                      button={buttonText || "Book nu"}
                      productName={productName}
                      replaceHistory={false}
                      searchOnBlur={false}
                      leadTimeInHours={self.productData["leadTimeInHours"] || 1.0}
                    />
                    <div className="w--normal"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Suspense>,
        parkingProductBookingStarterContainer,
      )
    }
  }

  performParkingSearch = (arrivalDate, arrivalTime, departureDate, departureTime, voucher, affiliateCode) => {
    const locale = this.lang || "da"
    const url = `${path.SEARCH(locale)}?ad=${arrivalDate}&at=${arrivalTime}&dd=${departureDate}&dt=${departureTime}${
      voucher ? "voucher=" + voucher : ""
    }${affiliateCode ? "&affiliate=" + affiliateCode : ""}`
    //  console.log (`booking pressed: ${url}`)
    window.location.assign(url)
  }

  // showPPBookingStarter() {
  //     document.getElementsByClassName("js-module-parking-product-bookingstarter").style.display =
  // }
}
